import {App as AntApp, ConfigProvider, Spin } from "antd";
import {Route, BrowserRouter, Routes} from "react-router-dom";
import React, {lazy, Suspense, useEffect, useRef, useState} from "react";
import {Auth} from "aws-amplify";
import {ClientViewFundingFromParams, ClientViewPageFromParams} from "./pages/client/ClientViewPage";
import {WhatsAppProvider} from "./providers/WhatsAppProvider";

import SussdWhatsAppProvider from "./providers/SussdWhatsAppProvider";
import WhatsAppScreen from "./components/whatsapp/WhatsAppScreen";
import {ErrorBoundary} from "./ErrorPage";
import RouteLogger from "./RouteLogger";
import LenderTestFiguresProvider
    from "./components/client/application-stages/_common/lender-tests/v4/LenderTestFiguresProvider";
import {UIStateProvider} from "./providers/UiContextProvider/UiStateContext";
const WorkflowMocker = lazy(()=> import ( "./components/stevo/workflow-mapper/V2/WorkflowMocker"));

const OtherWorkers = lazy(()=>import("./components/stevo/OtherWorkers"))
const StatementAlignment = lazy(() => import("./components/client/_new/statement-alignment/StatementAlignment"));
const WealthTables = lazy(() => import("./components/client/_new/wealth-tables/WealthTables"));
const SignoutPage = lazy(() => import("./auth/SignoutPage"));
const SidebarProvider = lazy(() => import("./providers/SidebarProvider"));
const MyAdminTasksProvider = lazy(() => import("./providers/MyAdminTasksProvider"));
const AdminEmailsProvider = lazy(() => import("./providers/AdminEmailsProvider"));
const LastViewedMortgagesProvider = lazy(() => import("./providers/LastViewedMortgagesProvider"));
const BackendUsersProvider = lazy(() => import("./providers/BackendUsersProvider"));
const UpcomingAppointmentProvider = lazy(() => import("./providers/UpcomingAppointmentProvider"));
const ApplicantActivitiesProvider = lazy(() => import("./providers/ApplicantActivitiesProvider"));
const ActiveMortgagesStageTasksProvider = lazy(() => import("./providers/ActiveMortgagesStageTasksProvider"));
const MortgagesMessagingProvider = lazy(() => import("./providers/mortgages-messaging/MortgagesMessagingProvider"));
const PermissionWrapper = lazy(() => import("./auth/PermissionWrapper"));
const PdfIdentifyProvider = lazy(() => import("./providers/PdfIdentifyProvider"));
const MortgagesProvider = lazy(() => import("./providers/MortgagesProvider"));
const LendersProvider = lazy(() => import("./providers/LendersProvider"));
const AdminDashboard = lazy(() => import("./pages/dashboard/Dashboard"));
const ClientDashboard = lazy(() => import("./pages/client/Dashboard"));
const DashboardEmailsPage = lazy(() => import("./pages/dashboard/EmailsPage"));
const ClientsListPage = lazy(() => import("./pages/dashboard/ClientsListPage"));
const ClientListWithFlowItems = lazy(() => import("./pages/dashboard/ClientListWithFlowItems"));
//const ActiveProductsPage = lazy(() => import("./pages/dashboard/ActiveProductsPage"));
//const UserProductWorkflowPage = lazy(() => import("./pages/dashboard/UserProductWorkflowPage"));
const SignInPage = lazy(() => import("./auth/SignInPage"));
const ClientEmailsPage = lazy(() => import("./pages/client/MortgageEmailsPage"));
const NotesPage = lazy(() => import("./pages/client/NotesPage"));
const TasksSuperComponent = lazy(() => import("./components/dashboard/tasks/TasksSuperComponent"));
const TasksPage = lazy(() => import("./pages/client/TasksPage"));
const SettingsPage = lazy(() => import("./pages/client/SettingsPage"));
const FinancialSummaryPage = lazy(() => import("./pages/client/FinancialSummaryPage"));
const DocumentBundlingPage = lazy(() => import("./pages/client/DocumentBundlingPage"));
const DocumentCreationPage = lazy(() => import("./pages/client/DocumentCreationPage"));
const ClientDashboardPage = lazy(() => import("./pages/client/DashboardPage"));
const BankingAnalysisPage = lazy(() => import("./pages/client/BankingAnalysisPage"));
const LendersPage = lazy(() => import("./pages/dashboard/LendersPage"));
const ClientViewPage = lazy(() => import("./pages/client/ClientViewPage"));
const ApplicationFormPage = lazy(() => import("./pages/client/ApplicationFormPage"));
const ApplicationUploadPage = lazy(() => import("./pages/client/ApplicationUploadPage"));
const CreateMutationsFile = lazy(() => import("./components/stevo/CreateMutationsFile"));
const TimeLine = lazy(() => import("./components/client/dashboard/TimeLine"));
const ConditionsPage = lazy(() => import("./pages/client/ConditionsPage"));
const Queries = lazy(() => import("./components/client/queries/Queries"));
const Overview = lazy(() => import("./components/client/overview/Overview"));
const Stats = lazy(() => import("./pages/dashboard/Stats"));
const ClientBars = lazy(() => import("./pages/dashboard/ClientBars"));
const ApplicationDocumentsPage = lazy(() => import("./pages/client/ApplicationDocumentsPage"));
const CreateNewMortgage = lazy(() => import("./pages/dashboard/CreateNewMortgage"));
const OutstandingItemsProvider = lazy(() => import("./providers/mortgage/OutstandingItemsProvider"));
const ReplyRequestsProvider = lazy(() => import("./providers/ReplyRequestsProvider"));
const ManagementApply = lazy(() => import("./components/client/application-stages/apply/ManagementApply"));
const ManagementPreApproval = lazy(() => import("./components/client/application-stages/pre-approval/ManagementPreApproval"));
const ManagementApproval = lazy(() => import("./components/client/application-stages/approval/ManagementApproval"));
const TimeSlots = lazy(() => import("./pages/dashboard/TimeSlots"));
const MyAdminTasks = lazy(() => import("./pages/dashboard/MyAdminTasks"));
const ManagementOnBoarding = lazy(() => import("./components/client/application-stages/on-boarding/ManagementOnBoarding"));
const Prep = lazy(() => import("./components/client/broker-assist-prep/Prep"));
const Landing = lazy(() => import("./components/dashboard/landing-page/Landing"));
const PdfGen = lazy(() => import("./components/stevo/PdfGen"));
const PendingUploads = lazy(() => import("./components/stevo/PendingUploads"));
const Ocr = lazy(() => import("./components/stevo/OCR"));
const PdfRecogniserV3 = lazy(() => import("./components/stevo/pdf-recogniser/RecogniserV4"));
const ManagementSign = lazy(() => import("./components/client/application-stages/sign/ManagementSign"));
const VerifiedLenderTests = lazy(() => import("./components/client/application-stages/_common/lender-tests/v2/VerifiedLenderTests"));
const TestPage = lazy(() => import("../_project/TestPage"));
const Dashboard = lazy(() => import("./components/client/_new/Dashboard"));
const DashboardRedirect = lazy(() => import("./components/client/_new/DashboardRedirect"));
const InitialForm = lazy(() => import("./components/client/application-stages/on-boarding/parts/InitialForm"));
const Qualification = lazy(() => import("./components/client/application-stages/on-boarding/parts/Qualification"));
const OptionsManager = lazy(() => import("./components/client/application-stages/on-boarding/parts/OptionsManager"));
const UploadsForApply = lazy(() => import("./components/client/application-stages/apply/parts/UploadsForApply"));
const MissingVerifiedUploads = lazy(() => import("./components/client/application-stages/_common/uploads/MissingVerifiedUploads"));
const ApplyQueries = lazy(() => import("./components/client/application-stages/apply/parts/ApplyQueries"));
const HaveAChat = lazy(() => import("./components/client/application-stages/_common/have-a-chat/HaveAChat"));
const Funding = lazy(() => import("./components/client/application-stages/_common/funding/Funding"));
const Accounts = lazy(() => import("./components/client/_new/savings-rate/Accounts"));
const FiguresUsed = lazy(() => import("./components/client/application-stages/_common/verified-figures/FiguresUsed"));
const BOF_Tabs = lazy(() => import("./components/client/_new/bof/BalanceOfFundsTabs.js"));
const SelectLender = lazy(() => import("./components/client/application-stages/sign/parts/SelectLender"));
const ApplyCustomerDocuments = lazy(() => import("./components/client/application-stages/apply/parts/ApplyCustomerDocuments"));
const Bundle = lazy(() => import("./components/client/application-stages/sign/parts/Bundle"));
const Details = lazy(() => import("./components/client/application-stages/pre-approval/parts/Details"));
const Property = lazy(() => import("./components/client/application-stages/pre-approval/parts/Property"));
const Solicitor = lazy(() => import("./components/client/application-stages/pre-approval/parts/Solicitor"));
const Agent = lazy(() => import("./components/client/application-stages/pre-approval/parts/Agent"));
const MpiInfo = lazy(() => import("./components/client/application-stages/_common/mortgage-protection-insurance/MpiInfo"));
const Quotes = lazy(() => import("./components/client/application-stages/_common/mortgage-protection-insurance/Quotes"));
const CustomerDocuments = lazy(() => import("./components/client/application-stages/pre-approval/parts/CustomerDocuments"));
const PreApprovedUploads = lazy(() => import("./components/client/application-stages/pre-approval/parts/Uploads"));
const PreApprovedExtendingSettings = lazy(() => import("./components/client/application-stages/pre-approval_extending/PreApprovedExtendingSettings"));
const ApprovedExtendingSettings = lazy(() => import("./components/client/application-stages/approval_extending/ApprovedExtendingSettings"));
const PreApprovalAdminDocuments = lazy(() => import("./components/client/application-stages/pre-approval/parts/PreApprovalAdminDocuments"));
const Page = lazy(() => import("./components/client/application-stages/_common/lender-tests/v3/Page"));
const LoanOffer = lazy(() => import("./components/client/application-stages/approval/parts/LoanOffer"));
const ApprovalCustomerDocuments = lazy(() => import("./components/client/application-stages/approval/parts/ApprovalCustomerDocuments"));
const Submission = lazy(() => import("./components/client/submission-screen/Submission"));
const ApprovalAdminDocuments = lazy(() => import("./components/client/application-stages/approval/parts/ApprovalAdminDocuments"));
const TestForMax = lazy(() => import("./components/client/lender-result-options/TestForMax"));
const TestForMaxUser = lazy(() => import("./components/client/lender-result-options-user/TestForMaxUser"));
const CreateSecondMortgage = lazy(() => import("./pages/dashboard/CreateSecondMortgage"));
const CoverNoteQueries = lazy(() => import("./components/client/_new/financial-sections-overview/AdvisorQueriesSection"));
//onst Annotate = lazy(()=> import("./components/client/application-stages/_common/uploads/v2/uploaded-file/UploadAnnotator"));

const UploadsOverview = lazy(() => import("./components/client/_new/uploads-overview/UploadsOverview"));
const AdvisorSectionTable = lazy(() => import("./components/client/_new/financial-sections-overview/AdvisorSectionTable"));
const WorkflowEditor = lazy(()=> import("./components/stevo/workflow-mapper/WorkflowEditor"));
const Workflow = lazy(()=> import("./components/stevo/workflow-mapper/WorkflowTest"));
const CoverNoteEditor = lazy(()=> import("./components/client/_new/covernote-editor/CoverNoteEditor"));
const StatementOfSuitabilityEditor = lazy(()=>import("./components/client/_new/statement-of-suitability-editor/StatementOfSuitabilityEditor"));
const LenderTestFiguresEditor = lazy(()=>import("./components/client/application-stages/_common/lender-tests/v4/LenderTestFiguresEditor"));
const LenderTestControl = lazy(()=>import("./components/client/application-stages/_common/lender-tests/v4/control-panel/LenderTestControl"));
const Vendors = lazy(()=> import("./components/vendor-things/Vendors"));
const AuditTrail = lazy(()=> import("./components/audit-trail/AuditTrail"));
const OverpaymentComparisonTool = lazy(()=> import("./components/over-payment-comparison-tool/OverpaymentComparionTool"));
const JacobLawClients = lazy(()=> import("./components/dashboard/jacobs-lay-clients/JacobsLawClients"));
const RLQFiddler = lazy(()=>import("./components/client/application-stages/_common/mortgage-protection-insurance/RLQFiddler"))
const NewUplaods = lazy(()=>import("./components/client/_new/uploads-overview/AllUploadsOverview"))
function App(props) {

    const [state, setState] = useState({haveUser: false})
    const user = useRef(null)
    const setUser = async () => {
        try {


            user.current = await Auth.currentAuthenticatedUser()
            if (user) {
                setState(s => ({...s, haveUser: true}))
            }
        } catch (e) {
            setState(s => ({...s, haveUser: true}))
        }
    }

    useEffect(() => {
        setUser()
    }, [user])

    if (!state.haveUser) {
        return null
    }

    function MainApp(props) {

        return (
            // <VerifiedLenderTestFiguresProvider>
            <PermissionWrapper>

                <WhatsAppProvider>
                    <UIStateProvider>
                        <LendersProvider>
                            <PdfIdentifyProvider>
                                <ActiveMortgagesStageTasksProvider>
                                    {/*<UploadAnnotator*/}
                                    <MortgagesProvider>
                                        <RouteLogger sub={user.current?.attributes?.sub}/>
                                        <OutstandingItemsProvider>
                                            <MortgagesMessagingProvider>
                                                <ReplyRequestsProvider>

                                                    <ApplicantActivitiesProvider>
                                                        <UpcomingAppointmentProvider>

                                                            <BackendUsersProvider>
                                                                <LastViewedMortgagesProvider>

                                                                    <AdminEmailsProvider>
                                                                        <MyAdminTasksProvider>
                                                                            <SidebarProvider>

                                                                                <ConfigProvider
                                                                                    theme={{

                                                                                        token: {

                                                                                            fontSize: 12,
                                                                                        },
                                                                                    }}
                                                                                >
                                                                                    <SussdWhatsAppProvider>
                                                                                        <LenderTestFiguresProvider>
                                                                                            <AdminDashboard {...props} />
                                                                                        </LenderTestFiguresProvider>

                                                                                    </SussdWhatsAppProvider>
                                                                                </ConfigProvider>


                                                                            </SidebarProvider>
                                                                        </MyAdminTasksProvider>
                                                                    </AdminEmailsProvider>

                                                                </LastViewedMortgagesProvider>
                                                            </BackendUsersProvider>
                                                        </UpcomingAppointmentProvider>
                                                    </ApplicantActivitiesProvider>


                                                </ReplyRequestsProvider>
                                            </MortgagesMessagingProvider>
                                        </OutstandingItemsProvider>
                                    </MortgagesProvider>
                                </ActiveMortgagesStageTasksProvider>
                            </PdfIdentifyProvider>
                        </LendersProvider>
                    </UIStateProvider>
                </WhatsAppProvider>

            </PermissionWrapper>
            // </VerifiedLenderTestFiguresProvider>
        )
    }

    const LazyLoad = ({children}) => {
        const Fallback = (<div className="d-col grow j-center a-cneter h-100"><Spin size="large"/></div>)
        return <Suspense fallback={Fallback}>{children}</Suspense>

    }

    return <AntApp>


        <BrowserRouter>

            <ErrorBoundary>
                <Routes>

                    <Route path="stevo-workflow" element={<BackendUsersProvider><LazyLoad><Workflow/></LazyLoad> </BackendUsersProvider>}/>
                    <Route path="stevo" element={<LazyLoad><PdfGen/></LazyLoad>}/>
                    <Route path="/signin" element={<LazyLoad><SignInPage/></LazyLoad>}/>
                    <Route path="/signout" element={<LazyLoad><SignoutPage/></LazyLoad>}/>
                    <Route path={'/user-app/:mortgageId'} element={<LazyLoad><MainApp sidebar={false}/></LazyLoad>}>
                        {
                            !!user.current && <Route index element={<LazyLoad><ClientViewPageFromParams user={user.current}/></LazyLoad>}/>
                        }

                    </Route>
                    <Route path={'/user-app-2/:mortgageId'} element={<LazyLoad><MainApp sidebar={false}/></LazyLoad>}>
                        {
                            !!user.current && <Route index element={<LazyLoad><ClientViewPageFromParams user={user.current} v={2}/></LazyLoad>}/>
                        }

                    </Route>
                    <Route path={'/user-funding/:mortgageId'} element={<LazyLoad><MainApp sidebar={false}/></LazyLoad>}>
                        {
                            !!user.current &&
                            <Route index element={<LazyLoad><ClientViewFundingFromParams user={user.current}/></LazyLoad>}/>
                        }

                    </Route>
                    <Route path={'/'} element={<LazyLoad><MainApp/></LazyLoad>}>
                        <Route path={'hours'} element={ <LazyLoad><OtherWorkers/></LazyLoad> }/>
                        {/*DASHBOARD ROUTES*/}
                        {/*<Route path="emails" element={<MortgageEmailsPage/>}/>*/}
                        <Route index element={<LazyLoad><Landing/></LazyLoad>}/>
                        <Route path="audit-trail" element={<LazyLoad><AuditTrail/></LazyLoad>}/>
                        <Route path="pending-uploads" element={<LazyLoad><PendingUploads/></LazyLoad>}/>
                        <Route path="my-tasks" element={<LazyLoad><TasksSuperComponent/></LazyLoad>}/>
                        <Route path="emails/:emailId/reply" element={<LazyLoad><DashboardEmailsPage/></LazyLoad>}/>
                        <Route path="emails/:emailId" element={<LazyLoad><DashboardEmailsPage/></LazyLoad>}/>
                        <Route path="emails" element={<LazyLoad><DashboardEmailsPage/></LazyLoad>}/>
                        <Route path="whatsapp" element={<LazyLoad><WhatsAppScreen user={user.current}/></LazyLoad>}/>
                        <Route path="lenders/:lenderId?/:section?" element={<LazyLoad><LendersPage/></LazyLoad>}/>
                        <Route path="vendors/:vendorId?/:folder?" element={<LazyLoad><Vendors/></LazyLoad>}/>
                        <Route path="new-mortgage-test-page" element={<LazyLoad><TestPage/></LazyLoad>}/>
                        <Route path="clients-status/:listType?" element={<LazyLoad><ClientListWithFlowItems/></LazyLoad>}/>
                        <Route path="clients/:categoryType" element={<LazyLoad><ClientsListPage/></LazyLoad>}/>
                        {/*<Route path="active-products" element={<LazyLoad><ActiveProductsPage/></LazyLoad>}/>*/}
                        {/*<Route path="active-products/:userProductID" element={<LazyLoad><UserProductWorkflowPage/></LazyLoad>}/>*/}
                        <Route path="stats" element={<LazyLoad><Stats/></LazyLoad>}/>
                        <Route path="client-bars" element={<LazyLoad><ClientBars/></LazyLoad>}/>
                        <Route path="my-settings/timeslots" element={<LazyLoad><TimeSlots/></LazyLoad>}/>
                        <Route path="my-tasks/:taskId?" element={<LazyLoad><MyAdminTasks/></LazyLoad>}/>
                        <Route path="workflow-editor" element={<LazyLoad><WorkflowEditor/></LazyLoad>}/>
                        <Route path="workflow-mocker" element={<LazyLoad><WorkflowMocker/></LazyLoad>}/>
                        <Route path="overpayment-comparison-tool" element={<LazyLoad><OverpaymentComparisonTool/></LazyLoad>}/>
                        <Route path="jacobs-law-clients" element={<LazyLoad><JacobLawClients/></LazyLoad>}/>
                        <Route path="mortgage/:mortgageId" element={<LazyLoad><ClientDashboard/></LazyLoad>}>

                            <Route index element={<LazyLoad><DashboardRedirect/></LazyLoad>}/>
                            <Route path="uploads-overview/:section?/:instanceId?" element={<LazyLoad><NewUplaods/></LazyLoad>}/>
                            <Route path="dashboard/:stage?" element={<LazyLoad><Dashboard/></LazyLoad>}/>
                            <Route path="workflow" element={<LazyLoad><Workflow/></LazyLoad>}/>
                            <Route path="cover-note-editor" element={<LazyLoad><CoverNoteEditor/></LazyLoad>}/>
                            <Route path="statement-of-suitability-editor" element={<LazyLoad><StatementOfSuitabilityEditor/></LazyLoad>}/>
                            <Route path="lender-test-4" element={<LazyLoad><LenderTestControl/></LazyLoad>}/>
                            <Route path="new-client-view" element={<LazyLoad><ClientViewPage user={user.current} new={true}/></LazyLoad>}/>
                            <Route path="new-client-view-2" element={<LazyLoad><ClientViewPage user={user.current} v={2}/></LazyLoad>}/>
                            <Route path="emails/:emailId/reply" element={<LazyLoad><ClientEmailsPage/></LazyLoad>}/>
                            <Route path="emails/:emailId" element={<LazyLoad><ClientEmailsPage/></LazyLoad>}/>
                            <Route path="emails" element={<LazyLoad><ClientEmailsPage/></LazyLoad>}/>
                            <Route path="documents" element={<LazyLoad><ApplicationDocumentsPage/></LazyLoad>}/>
                            <Route path="settings" element={<LazyLoad><SettingsPage/></LazyLoad>}/>
                            <Route path="evaluation/data" element={<LazyLoad><InitialForm/></LazyLoad>}/>
                            <Route path="evaluation/test" element={<LazyLoad><Qualification/></LazyLoad>}/>
                            <Route path="evaluation/figures" element={<LazyLoad><FiguresUsed useVerified={false}/></LazyLoad>}/>
                            <Route path="evaluation/options" element={<OptionsManager/>}/>
                            <Route path="application/form/:sectionName?/:index?" element={<LazyLoad><ApplicationFormPage/></LazyLoad>}/>

                            <Route path="application/statement-alignment" element={<LazyLoad><StatementAlignment/></LazyLoad>}/>
                            <Route path="application/queries-overview" element={<LazyLoad><CoverNoteQueries/></LazyLoad>}/>

                            <Route path="application/wealth" element={<LazyLoad><WealthTables/></LazyLoad>}/>
                            <Route path="application/uploads-sections/:stage?/:sectionName?/:sectionIndex?" element={<LazyLoad><UploadsOverview/></LazyLoad>}/>
                            <Route path="application/uploads-sections-table" element={<LazyLoad><AdvisorSectionTable/></LazyLoad>}/>
                            <Route path="application/uploads/:uploadId?" element={<LazyLoad><UploadsForApply/></LazyLoad>}/>
                            <Route path="application/upload-problems" element={<LazyLoad><MissingVerifiedUploads stage="apply"/></LazyLoad>}/>
                            <Route path="application/queries/:queryId?" element={<LazyLoad><ApplyQueries/></LazyLoad>}/>
                            <Route path="application/have-a-chat" element={<LazyLoad><HaveAChat/></LazyLoad>}/>
                            <Route path="application/funding" element={<LazyLoad><Funding/></LazyLoad>}/>
                            <Route path="application/accounts" element={<LazyLoad><Accounts/></LazyLoad>}/>
                            <Route path="application/queries" element={<LazyLoad><ApplyQueries/></LazyLoad>}/>
                            <Route path="application/figures" element={<LazyLoad><FiguresUsed useVerified={true}/></LazyLoad>}/>
                            <Route path="balance-of-funds" element={<LazyLoad><BOF_Tabs/></LazyLoad>}/>
                            <Route path="application/figures/preapproved" element={<LazyLoad><FiguresUsed useVerified={true} stage="PREAPPROVAL"/></LazyLoad>}/>
                            <Route path="application/summary" element={<LazyLoad><Prep/></LazyLoad>}/>
                            <Route path="application/select-lender" element={<LazyLoad><SelectLender/></LazyLoad>}/>
                            <Route path="signing/tests" element={<LazyLoad><VerifiedLenderTests/></LazyLoad>}/>
                            <Route path="figures/tests" element={<LazyLoad><Page/></LazyLoad>}/>
                            <Route path="figures/test-for-max" element={<LazyLoad><TestForMax/></LazyLoad>}/>
                            <Route path="figures/user-for-max" element={<LazyLoad><TestForMaxUser/></LazyLoad>}/>
                            <Route path="figures/user-max" element={<LazyLoad><TestForMax/></LazyLoad>}/>
                            <Route path="signing/generate-customer-docs" element={<LazyLoad><ApplyCustomerDocuments/></LazyLoad>}/>
                            <Route path="signing/package" element={<LazyLoad><Bundle/></LazyLoad>}/>
                            <Route path="preapproved/aipClass" element={<LazyLoad><Details/></LazyLoad>}/>
                            <Route path="preapproved/property" element={<LazyLoad><Property/></LazyLoad>}/>
                            <Route path="preapproved/solicitor" element={<LazyLoad><Solicitor/></LazyLoad>}/>
                            <Route path="preapproved/agent" element={<LazyLoad><Agent/></LazyLoad>}/>
                            <Route path="preapproved/medical/fiddler" element={<LazyLoad><RLQFiddler/></LazyLoad>}/>
                            <Route path="preapproved/medical" element={<LazyLoad><MpiInfo/></LazyLoad>}/>
                            <Route path="preapproved/mpi-quotes" element={<LazyLoad><Quotes/></LazyLoad>}/>
                            <Route path="preapproved/generate-customer-docs" element={<LazyLoad><CustomerDocuments/></LazyLoad>}/>
                            <Route path="preapproved/uploads" element={<LazyLoad><PreApprovedUploads/></LazyLoad>}/>
                            <Route path="preapproved/package" element={<LazyLoad><PreApprovalAdminDocuments/></LazyLoad>}/>
                            <Route path="preapproved-extending" element={<LazyLoad><PreApprovedExtendingSettings/></LazyLoad>}/>
                            <Route path="mortgage-protection-insurance" element={<LazyLoad><MpiInfo/></LazyLoad>}/>
                            <Route path="approved/loan-offer" element={<LazyLoad><LoanOffer/></LazyLoad>}/>
                            <Route path="approved/customer-documents" element={<LazyLoad><ApprovalCustomerDocuments/></LazyLoad>}/>
                            <Route path="approved/admin-documents" element={<LazyLoad><ApprovalAdminDocuments/></LazyLoad>}/>
                            <Route path="approved-extending" element={<LazyLoad><ApprovedExtendingSettings/></LazyLoad>}/>
                            <Route path="submission" element={<LazyLoad><Submission/></LazyLoad>}/>
                        </Route>

                        <Route path="client/:mortgageId" element={<LazyLoad><ClientDashboard/></LazyLoad>}>

                            <Route index element={<LazyLoad><ClientDashboardPage/></LazyLoad>}/>
                            <Route path="create-new-mortgage/:type?" element={<LazyLoad><CreateSecondMortgage/></LazyLoad>}/>
                            <Route path="prep" element={<LazyLoad><Prep/></LazyLoad>}/>
                            <Route path="overview" element={<LazyLoad><Overview/></LazyLoad>}/>
                            <Route path="application-forms/:sectionName?/:index?" element={<LazyLoad><ApplicationFormPage/></LazyLoad>}/>
                            <Route path="application-uploads/:sectionName?/:index?" element={<LazyLoad><ApplicationUploadPage/></LazyLoad>}/>

                            <Route path="setup-management" element={<LazyLoad><ManagementOnBoarding key="setupManagement"/></LazyLoad>}/>


                            <Route path="apply-management" element={<LazyLoad><ManagementApply key="applyManagement"/></LazyLoad>}/>

                            <Route path="application-tasks" element={<LazyLoad><ConditionsPage stage="APPLY"/></LazyLoad>}/>
                            <Route path="application-queries" element={<LazyLoad><Queries stage="APPLY"/></LazyLoad>}/>
                            <Route path="application-documents" element={<LazyLoad><ApplicationDocumentsPage/></LazyLoad>}/>
                            {/*<Route path="application-management" element={<ApplicationManagement/>}/>*/}

                            <Route path="sign-management" element={<LazyLoad><ManagementSign key="signManagement"/></LazyLoad>}/>

                            <Route path="pre-approval-tasks" element={<LazyLoad><ConditionsPage stage="PREAPPROVAL"/></LazyLoad>}/>
                            <Route path="pre-approval-queries" element={<LazyLoad><Queries stage="PREAPPROVAL"/></LazyLoad>}/>
                            <Route path="pre-approval-management" element={<LazyLoad><ManagementPreApproval/></LazyLoad>}/>
                            <Route path="approval-tasks" element={<LazyLoad><ConditionsPage stage="APPROVAL"/></LazyLoad>}/>
                            <Route path="approval-queries" element={<LazyLoad><Queries stage="APPROVAL"/></LazyLoad>}/>
                            <Route path="approval-management" element={<LazyLoad><ManagementApproval/></LazyLoad>}/>

                            <Route path="timeline/:stageName" element={<LazyLoad><TimeLine large/></LazyLoad>}/>
                            <Route path="emails/:emailId/reply" element={<LazyLoad><ClientEmailsPage/></LazyLoad>}/>
                            <Route path="emails/:emailId" element={<LazyLoad><ClientEmailsPage/></LazyLoad>}/>
                            <Route path="emails" element={<LazyLoad><ClientEmailsPage/></LazyLoad>}/>
                            <Route path="notes" element={<LazyLoad><NotesPage/></LazyLoad>}/>
                            <Route path="tasks/:id?" element={<LazyLoad><TasksPage/></LazyLoad>}/>
                            <Route path="settings" element={<LazyLoad><SettingsPage/></LazyLoad>}/>
                            <Route path="document-bundling" element={<LazyLoad><DocumentBundlingPage/></LazyLoad>}/>
                            <Route path="document-creation" element={<LazyLoad><DocumentCreationPage/></LazyLoad>}/>
                            <Route path="banking-analysis" element={<LazyLoad><BankingAnalysisPage/></LazyLoad>}/>
                            <Route path="financial-summary" element={<LazyLoad><FinancialSummaryPage/></LazyLoad>}/>
                            <Route path="drawdown" element={<>Empty</>}/>
                            <Route path="client-view" element={<LazyLoad><ClientViewPage user={user.current}/></LazyLoad>}/>
                            <Route path="new-client-view" element={<LazyLoad><ClientViewPage user={user.current} new={true}/></LazyLoad>}/>
                        </Route>
                        <Route path="create-definitions" element={<LazyLoad><CreateMutationsFile/></LazyLoad>}/>
                        <Route path="create-offline-mortgage" element={<LazyLoad><CreateNewMortgage/></LazyLoad>}/>

                        <Route path="ocr" element={<LazyLoad><Ocr/></LazyLoad>}/>
                        <Route path="recognise" element={<LazyLoad><PdfRecogniserV3/></LazyLoad>}/>


                    </Route>
                    <Route path='*' element={<div className="d-row a-center j-center"><h1>Not Found!</h1></div>}/>

                </Routes>
            </ErrorBoundary>
        </BrowserRouter>
    </AntApp>
}

export default App
